import React from 'react';
import { aibTheme } from '@uikit/Theme/Theme';
import { createSvgIcon } from './utils/createSvgIcon';

const color = aibTheme.palette.secondary.main;

export const IconPencil = createSvgIcon(
  'pencil',
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2941 2.75C16.4526 2.75 15.6455 3.0843 15.0505 3.67935L3.28578 15.4441C3.13501 15.5948 3.02804 15.7838 2.97633 15.9906L2.03515 19.7553C1.93492 20.1562 2.05239 20.5803 2.34461 20.8725C2.63682 21.1648 3.06092 21.2822 3.46183 21.182L7.22654 20.2408C7.4334 20.1891 7.62232 20.0821 7.77309 19.9314L19.5378 8.16666C19.8324 7.87202 20.0662 7.52223 20.2256 7.13726C20.3851 6.7523 20.4671 6.33969 20.4671 5.92301C20.4671 5.50632 20.3851 5.09372 20.2256 4.70875C20.0662 4.32378 19.8324 3.97399 19.5378 3.67935C19.2432 3.38471 18.8934 3.15099 18.5084 2.99153C18.1234 2.83207 17.7108 2.75 17.2941 2.75ZM16.7143 5.34313C16.8681 5.18934 17.0766 5.10294 17.2941 5.10294C17.4018 5.10294 17.5085 5.12415 17.608 5.16536C17.7075 5.20658 17.7979 5.26698 17.874 5.34313C17.9502 5.41928 18.0106 5.50969 18.0518 5.60918C18.093 5.70868 18.1142 5.81531 18.1142 5.92301C18.1142 6.0307 18.093 6.13734 18.0518 6.23683C18.0106 6.33633 17.9502 6.42673 17.874 6.50288L6.33973 18.0372L4.7934 18.4237L5.17998 16.8774L16.7143 5.34313Z"
      fill={color}
    />
    <path
      d="M11.6471 19.9265C11.6471 20.7062 12.2265 21.3382 12.9412 21.3382H20.7059C21.4206 21.3382 22 20.7062 22 19.9265C22 19.1468 21.4206 18.5147 20.7059 18.5147H12.9412C12.2265 18.5147 11.6471 19.1468 11.6471 19.9265Z"
      fill={color}
    />
  </g>,
  24,
  24,
  'none'
);
